import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const multipartHeaders = () => {
  const headers = { ...authHeader({ contentType: "multipart/form-data" }) };
  delete headers["Content-Type"];
  return headers;
};

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["formdata"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/form/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["formdata", "delete_form_element_id"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/form/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  // Paginator links may be query-only. Never resolve them against /settings
  // or send authentication to a host supplied by a legacy pagination link.
  const nextQuery = next_page_url && next_page_url.includes("?")
    ? next_page_url.split("?")[1].split("#")[0]
    : "";
  const query = new URLSearchParams(nextQuery);
  if (!next_page_url && page) query.set("page", page);
  new URLSearchParams(sortstring).forEach((value, key) => query.set(key, value));
  const action = `afterlogin/form/view?${query.toString()}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/form/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const formelementtype = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/form/formelementtype`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const preview = (values) => {
  const result = values && values.result ? values.result : "";
  const location = values && values.pathname;
  const action = `widget/formpreview`;
  const data = {
    action: action,
    pagination: false, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    location: location,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};
const previewcreate = (values = {}) => {
  const formData = new FormData();
  const preview = Array.isArray(values.formpreview) ? values.formpreview : [];
  const submissionKey = typeof values.submission_key === "string"
    ? values.submission_key.trim()
    : "";
  Object.keys(values).forEach((value) => {
    if (!["formpreview", "submission_key"].includes(value) && values[value] !== undefined && values[value] !== null) {
      formData.append(value, values[value]);
    }
  });

  const answers = [];
  preview.forEach((item) => {
    if (!item || item.id === undefined || item.id === null) return;
    const formType = item.form_type || item.form_element_type?.form_type;
    const isFile = ["file", "signature"].includes(String(formType || "").toLowerCase());
    if (isFile) {
      if (item.answer) formData.append(`Signature_${item.id}`, item.answer);
      return;
    }
    const answer = Array.isArray(item.answer) || (item.answer && typeof item.answer === "object")
      ? JSON.stringify(item.answer)
      : String(item.answer ?? "");
    answers.push({ form_element_id: Number(item.id), answer });
    if (item.name) formData.append(item.name, answer);
  });
  formData.append("answers", JSON.stringify(answers));
  if (preview.length) formData.append("formpreview", JSON.stringify(preview));
  const action = "widget/formpreview/store";
  return axios.post(API_URL + action, formData, {
    headers: {
      ...multipartHeaders(),
      ...(submissionKey ? { "Idempotency-Key": submissionKey } : {}),
    },
  });
};
const usercheck = (values = {}) => {
  const formData = new FormData();
  ["uid", "email", "phone_number"].forEach((value) => {
    if (values[value] !== undefined && values[value] !== null) formData.append(value, values[value]);
  });
  const action = "widget/formpreview/usercheck";
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

// const previewcreate = (values) => {
//   const formData = new FormData();
//   for (let key in values) {
//     if (values.hasOwnProperty(key)) {
//       // Check if the current value is an array
//       if (Array.isArray(values[key])) {
//         // Handle arrays of objects
//         values[key].forEach(item => {
//           if (item.form_type === "file") {
//             // Append the File object with a custom name
//             formData.append(key, item.answer, item.name);
//           } else {
//             // Append other values directly
//             formData.append(key, item.answer);
//           }
//         });
//       } else {
//         // Append other values directly
//         formData.append(key, values[key]);
//       }
//     }
//   }
//   const action = "widget/formpreview/store";
//   formData.append("action", action);
//   console.log('formData: ', formData);
//   return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
// };


const formApiController = {
  create,
  update,
  view,
  deleted,
  formelementtype,
  preview,
  previewcreate,
  usercheck
};
export default formApiController;
